// import React from "react";
import { Spin, Tooltip, message } from "antd";
import React, { useEffect, useState } from "react";
// import { Switch } from "antd";
import { Link, useParams } from "react-router-dom";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";

import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import Table from "../../../../../../core/pagination/datatable";
const NotesTab = () => {
  const [isEdit, setIsEdit] = useState(false);

  // const avatarColors = [
  //   "#0EA5E9", // Sky Blue
  //   "#10B981", // Emerald
  //   "#F59E0B", // Amber
  //   "#EF4444", // Red
  //   "#8B5CF6", // Violet
  //   "#EC4899", // Pink
  //   "#14B8A6", // Teal
  //   "#6366F1", // Indigo
  // ];

  // const getAvatarColor = (name) => {
  //   const index = name.charCodeAt(0) % avatarColors.length;
  //   return avatarColors[index];
  // };

  const renderTooltip = (text) => {
    if (!text) return "N/A";

    return text.length > 55 ? (
      <Tooltip title={text}>
        <span>{text.substring(0, 55)}...</span>
      </Tooltip>
    ) : (
      text
    );
  };

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) =>
        (a.description || "").localeCompare(b.description || ""),

      render: (text) => renderTooltip(text || "N/A"),
    },

    {
      title: "Added From",
      dataIndex: "added_by_name",
      key: "added_by_name",

      sorter: (a, b) =>
        (a.added_by_name || "").localeCompare(b.added_by_name || ""),

      render: (text) => (
        <div className="d-flex align-items-center">
          {/* <div
            className="rounded-circle text-white d-flex align-items-center justify-content-center me-2"
            style={{
              width: 36,
              height: 36,
              fontSize: 13,
              fontWeight: 600,
              backgroundColor: getAvatarColor(text),
            }}
          >
            {text
              ?.split(" ")
              .map((word) => word[0])
              .join("")
              .substring(0, 2)
              .toUpperCase()}
          </div> */}

          <span className="fw-medium">
            {" "}
            <i className="fa fa-user text-info me-2"></i>
            {text || "N/A"}
          </span>
        </div>
      ),
    },

    {
      title: "Date",
      dataIndex: "dateadded",
      key: "date",

      sorter: (a, b) => new Date(a.dateadded) - new Date(b.dateadded),

      render: (text) => {
        if (!text) return "N/A";

        const date = new Date(text);

        const formattedDate = `${String(date.getDate()).padStart(
          2,
          "0",
        )}-${String(date.getMonth() + 1).padStart(
          2,
          "0",
        )}-${date.getFullYear()}`;

        return (
          <div>
            <i className="fa-regular fa-calendar text-primary me-2"></i>
            {formattedDate}
          </div>
        );
      },
    },

    {
      title: "Time",
      dataIndex: "dateadded",
      key: "time",

      sorter: (a, b) => new Date(a.dateadded) - new Date(b.dateadded),

      render: (text) => {
        if (!text) return "N/A";

        const date = new Date(text);

        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });

        return (
          <div>
            <i className="fa-regular fa-clock text-danger me-2"></i>
            {formattedTime}
          </div>
        );
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",

      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action ">
            <Link
              to="#"
              className="me-2 p-2 shadow-sm"
              data-bs-toggle="modal"
              data-bs-target="#noteModal"
              onClick={() => {
                setIsEdit(true);

                setNoteData({
                  id: record.id,
                  description: record.description,
                  date_contacted: record.date_contacted,
                });
              }}
            >
              <i className="ti ti-pencil text-primary"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const { id } = useParams();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId);

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteLoading, setAddNoteLoading] = useState(false);

  const [noteData, setNoteData] = useState({
    id: null,
    description: "",
    date_contacted: null,
  });
  // const [updateNoteLoading, setUpdateNoteLoading] = useState(false);

  console.log(addNoteLoading);

  //view notes integration

  const fetchNotes = async () => {
    try {
      setNotesLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}notes/GetNotes?rel_id=${id}&rel_type=Customer`,
      );

      const data = await response.json();

      if (data.Status) {
        setNotes(data.ResultData || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchNotes();
    }
  }, [id]);

  // add note integration

  const handleAddNote = async () => {
    if (!noteData.description.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setAddNoteLoading(true);

      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

      const response = await fetch(`${BASE_CRM_URL}notes/AddNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rel_id: id,
          rel_type: "Customer",
          description: noteData.description,
          addedfrom: userDetails.staffid,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
        });

        fetchNotes();

        setNoteData({
          id: null,
          description: "",
          date_contacted: null,
        });

        setIsEdit(false);

        document
          .querySelector("#noteModal .btn[data-bs-dismiss='modal']")
          .click();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      message.error("Something went wrong.");
    } finally {
      setAddNoteLoading(false);
    }
  };

  // edit note integration

  const handleUpdateNote = async () => {
    if (!noteData.description.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setAddNoteLoading(true);

      const response = await fetch(`${BASE_CRM_URL}notes/UpdateNote`, {
        method: "Post", // Change if your API expects POST
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: noteData.id,
          description: noteData.description,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success Note Update Successfully",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
        });

        fetchNotes();

        setIsEdit(false);

        setNoteData({
          id: null,
          description: "",
          date_contacted: null,
        });

        document
          .querySelector("#noteModal .btn[data-bs-dismiss='modal']")
          .click();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
        });
      }
    } catch (err) {
      message.error("Something went wrong.");
    } finally {
      setAddNoteLoading(false);
    }
  };

  return (
    <>
      <div>
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-success btn-sm me-2"
                  data-bs-toggle="modal"
                  data-bs-target="#noteModal"
                  onClick={() => {
                    setIsEdit(false);

                    setNoteData({
                      id: null,
                      description: "",
                      date_contacted: null,
                    });
                  }}
                >
                  <i className="ti ti-circle-plus fs-4"> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              {notesLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={notes} />
              )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>

      <div
        className="modal fade"
        id="noteModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        {/* Overall Loading Spinner */}
        {addNoteLoading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 9999,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {isEdit ? "Edit Note" : "Add New Note"}
              </h5>

              <div className="d-flex  gap-2">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#e40d22",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Close"
                >
                  <i className="fa fa-times" />
                </button>

                <button
                  type="button"
                  // onClick={addContact}
                  onClick={isEdit ? handleUpdateNote : handleAddNote}
                  // disabled={saving}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#07f083",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Save"
                >
                  {addNoteLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  ) : (
                    <i className="fa fa-check" />
                  )}
                </button>
              </div>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Description
                </label>

                <textarea
                  rows={4}
                  className="form-control"
                  placeholder="Enter Description"
                  value={noteData.description}
                  onChange={(e) =>
                    setNoteData({
                      ...noteData,
                      description: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light border"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={isEdit ? handleUpdateNote : handleAddNote}
                disabled={addNoteLoading}
              >
                <i
                  className={`fa-solid ${
                    isEdit ? "fa-pen-to-square" : "fa-floppy-disk"
                  } me-2`}
                ></i>

                {isEdit ? "Update" : "Save"}
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotesTab;
